<div class="container mx-auto px-4 py-6">
  <!-- Header -->
  <div class="mb-6">
    <div class="flex items-center justify-between">
      <div>
        <h1 class="text-3xl font-bold text-gray-800">📨 Leads (Auditoria)</h1>
        <p class="text-gray-600 mt-2">Acompanhe todas as mensagens enviadas aos fornecedores</p>
      </div>
      <div class="text-right">
        <div class="text-4xl font-bold text-blue-600">{{ total }}</div>
        <p class="text-sm text-gray-600">Total de Leads</p>
      </div>
    </div>
  </div>

  <!-- Filtros -->
  <div class="bg-white rounded-lg shadow p-6 mb-6">
    <div class="flex items-center justify-between mb-4">
      <h2 class="text-lg font-semibold text-gray-800">🔍 Filtros</h2>
      <div *ngIf="activeFiltersCount > 0" class="text-sm">
        <span class="bg-blue-100 text-blue-800 px-3 py-1 rounded-full font-semibold">
          {{ activeFiltersCount }} filtro(s) ativo(s)
        </span>
      </div>
    </div>

    <!-- Linha 1: Fornecedor e Email do Cliente -->
    <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">👥 Fornecedor</label>
        <select [(ngModel)]="fornecedorId" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
          <option value="">-- Todos os fornecedores --</option>
          <option *ngFor="let f of fornecedores" [value]="f.id">
            {{ f.nome }} {{ f.cidade ? '(' + f.cidade + ')' : '' }}
          </option>
        </select>
      </div>

      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">📧 Email do Cliente</label>
        <input [(ngModel)]="clienteEmail" type="email" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="cliente@exemplo.com">
      </div>

      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">📮 Status Email</label>
        <select [(ngModel)]="emailSent" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
          <option [ngValue]="undefined">-- Todos --</option>
          <option [ngValue]="'true'">✓ Enviado</option>
          <option [ngValue]="'false'">✗ Não enviado</option>
        </select>
      </div>
    </div>

    <!-- Linha 2: Status de Leitura e Período -->
    <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">👁️ Status de Leitura</label>
        <select [(ngModel)]="isRead" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
          <option [ngValue]="undefined">-- Todos --</option>
          <option [ngValue]="'true'">✓ Lido</option>
          <option [ngValue]="'false'">⏳ Pendente</option>
        </select>
      </div>

      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">📅 Data Início</label>
        <input [(ngModel)]="dataInicio" type="date" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
      </div>

      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">📅 Data Fim</label>
        <input [(ngModel)]="dataFim" type="date" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
      </div>
    </div>

    <!-- Botões de Ação -->
    <div class="flex gap-2 pt-4 border-t">
      <button (click)="load()" class="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 font-medium transition">
        🔍 Filtrar
      </button>
      <button (click)="resetFilters()" [disabled]="activeFiltersCount === 0" class="px-6 py-2 border border-gray-300 rounded-md hover:bg-gray-50 font-medium transition disabled:opacity-50 disabled:cursor-not-allowed">
        ✕ Limpar Filtros
      </button>
    </div>
  </div>

  <!-- Loading -->
  <div *ngIf="loading" class="flex justify-center items-center py-12">
    <app-spinner></app-spinner>
  </div>

  <!-- Tabela de Leads -->
  <div *ngIf="!loading" class="bg-white rounded-lg shadow overflow-hidden">
    <div *ngIf="items.length === 0" class="p-12 text-center">
      <div class="text-6xl mb-4">📭</div>
      <p class="text-gray-600 text-lg">Nenhum lead encontrado com os filtros selecionados.</p>
    </div>

    <div *ngIf="items.length > 0" class="overflow-x-auto">
      <table class="min-w-full divide-y divide-gray-200">
        <thead class="bg-gray-50">
          <tr>
            <th class="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">Fornecedor</th>
            <th class="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">Cliente</th>
            <th class="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">Contato</th>
            <th class="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">LGPD</th>
            <th class="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">Email</th>
            <th class="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">Lido</th>
            <th class="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">Data/Hora</th>
            <th class="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">Ações</th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
          <tr *ngFor="let l of items" class="hover:bg-gray-50 transition">
            <td class="px-6 py-4">
              <div class="text-sm font-semibold text-gray-900">{{ l.fornecedor?.nome }}</div>
            </td>
            <td class="px-6 py-4">
              <div class="text-sm font-medium text-gray-900">{{ l.clienteName }}</div>
              <div class="text-xs text-gray-600">{{ l.clienteEmail }}</div>
            </td>
            <td class="px-6 py-4">
              <div class="text-sm text-gray-900">{{ l.clientePhone }}</div>
            </td>
            <td class="px-6 py-4">
              <span [class]="'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold ' + (l.lgpdConsent ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800')">
                {{ l.lgpdConsent ? '✓ Autorizado' : '✗ Não' }}
              </span>
            </td>
            <td class="px-6 py-4">
              <span [class]="'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold ' + (l.emailSent ? 'bg-blue-100 text-blue-800' : 'bg-yellow-100 text-yellow-800')">
                {{ l.emailSent ? '✓ Enviado' : '⚠️ Pendente' }}
              </span>
            </td>
            <td class="px-6 py-4">
              <span [class]="'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold ' + (l.isRead ? 'bg-purple-100 text-purple-800' : 'bg-gray-100 text-gray-800')">
                {{ l.isRead ? '✓ Lido' : '⏳ Pendente' }}
              </span>
            </td>
            <td class="px-6 py-4 whitespace-nowrap">
              <div class="text-sm font-medium text-gray-900">{{ l.createdAt | date:'dd/MM/yyyy' }}</div>
              <div class="text-xs text-gray-500">{{ l.createdAt | date:'HH:mm:ss' }}</div>
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm space-x-2">
              <button (click)="openWhatsApp(l)" [disabled]="!l.clientePhone" title="Abrir WhatsApp do cliente" class="text-green-600 hover:text-green-900 hover:underline font-medium disabled:opacity-40 disabled:cursor-not-allowed">
                💬 WhatsApp
              </button>
              <button (click)="resendEmail(l)" title="Reenviar email para o fornecedor" class="text-blue-600 hover:text-blue-900 hover:underline font-medium">
                📧 Reenviar
              </button>
              <a [routerLink]="['/admin/leads', l.id]" title="Ver detalhes completos" class="text-gray-700 hover:text-gray-900 hover:underline font-medium">
                👁️ Detalhe
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Paginação -->
    <div class="bg-white px-4 py-3 border-t border-gray-200 sm:px-6">
      <div class="flex items-center justify-between">
        <div class="text-sm text-gray-700">
          Mostrando
          <span class="font-semibold">{{ (page - 1) * pageSize + 1 }}</span>
          até
          <span class="font-semibold">{{ displayEnd() }}</span>
          de
          <span class="font-semibold">{{ total }}</span>
          leads
        </div>
        <div>
          <app-pagination [page]="page" [pageSize]="pageSize" [total]="total" (pageChange)="onPageChange($event)"></app-pagination>
        </div>
      </div>
    </div>
  </div>
</div>
